if (!customElements.get('evani-contact-modal')) {
  customElements.define('evani-contact-modal', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.paths = this.dataset.contactPaths.split('|');
      this.optionsPanel = this.querySelector('[data-contact-options]');
      this.formPanel = this.querySelector('[data-contact-form]');
      this.onClick = this.handleClick.bind(this);
      this.onClose = this.handleClose.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onSectionLoad = this.enhanceLinks.bind(this);
      document.addEventListener('click', this.onClick, true);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', this.onKeydown);
      this.enhanceLinks();
      if (this.querySelector('[data-contact-confirmation], [data-contact-error]')) {
        this.open();
        this.showForm(false);
      } else if (location.hash === '#contact-us-modal') {
        this.open();
      }
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.removeEventListener('click', this.onClick, true);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('keydown', this.onKeydown);
    }

    isContactLink(link) {
      if (!link || this.contains(link) || link.hasAttribute('download') || link.target === '_blank') return false;
      const url = new URL(link.href, location.origin);
      const label = (link.getAttribute('aria-label') || link.textContent).trim().replace(/\s+/g, ' ').toLowerCase();
      return url.origin === location.origin && this.paths.includes(url.pathname.replace(/\/$/, '')) && (label === 'contact us' || link.classList.contains('js-contact-us-header'));
    }

    enhanceLinks() {
      document.querySelectorAll('a[href]').forEach(link => {
        if (this.isContactLink(link)) {
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', this.dialog.id);
        }
      });
    }

    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger || document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.optionsPanel.hidden = false;
      this.formPanel.hidden = true;
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden';
    }

    showForm(focus = true) {
      this.optionsPanel.hidden = true;
      this.formPanel.hidden = false;
      this.dialog.scrollTop = 0;
      if (focus) this.formPanel.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
    }

    showOptions() {
      this.optionsPanel.hidden = false;
      this.formPanel.hidden = true;
      this.dialog.scrollTop = 0;
      this.querySelector('[data-contact-message]').focus({ preventScroll: true });
    }

    handleClose() {
      document.documentElement.style.overflow = this.previousOverflow || '';
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        return;
      }
      if (event.key !== 'Tab') return;
      event.stopPropagation();
      const focusable = [...this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),textarea:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[href]');
      if (!event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && this.isContactLink(link)) {
        event.preventDefault();
        this.open(link);
        return;
      }
      if (!this.dialog.open) return;
      if (event.target.closest('[data-contact-close]')) {
        this.dialog.close();
      } else if (event.target.closest('[data-contact-message]')) {
        event.preventDefault();
        this.showForm();
      } else if (event.target.closest('[data-contact-back]')) {
        this.showOptions();
      } else if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
    }
  });
}
